module.exports = __webpack_public_path__ + "img/appelkWeary.73cb0265.png";